import { Autocomplete, Button, TextField } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TextInput from "../../../../components/inputs/textInput";

const CurrencyModal = ({
  data,
  changedData,
  setChangedData,
  setData,
  currencyOption,
  defaults,
}) => {
  const { id } = useParams();

  const navigate = useNavigate();
  const [inputValue, setInputValue] = React.useState();
  const [typed, setTyped] = useState(false);
  useEffect(() => {
    if (
      currencyOption?.find(
        (item) => item?.guidRecNo === changedData?.guidCurrencyTypeRecNo
      )?.chName
    ) {
      setInputValue(
        currencyOption?.find(
          (item) => item?.guidRecNo === changedData?.guidCurrencyTypeRecNo
        )?.chName
      );
    } else {
      setInputValue(
        currencyOption?.find(
          (item) => item?.guidRecNo === defaults?.guidCurrencyTypeRecNo
        )?.chName
      );
    }
  }, [changedData]);
  return (
    <div>
      {" "}
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { md: "90%", xs: "90%" },
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 2,
          pb: { md: 2, xs: 11 },
          borderRadius: 2,
          overflow: "auto",
          maxHeight: "95%",
          maxWidth: "400px",
        }}
      >
        <div className="flex flex-col gap-4">
          <div className="border-b border-solid border-[#bbcfec] pb-4">
            <h2 className="text-sm font-bold">{data?.chTitle}</h2>
          </div>
          <TextInput
            label="عنوان ارسالی"
            onChange={(e) =>
              setChangedData({ ...changedData, chPurchStuffSendName: e })
            }
            value={changedData.chPurchStuffSendName}
          />
          <TextInput
            label=" میزان ارز"
            onChange={(e) =>
              setChangedData({ ...changedData, flCurrencyAmount: Number(e) })
            }
            value={changedData.flCurrencyAmount}
            number
            noSepreate
          />
          {inputValue !== undefined && (
            <Autocomplete
              id="currency"
              inputValue={inputValue}
              onInputChange={(event, newInputValue) => {
                if ((newInputValue || typed) && newInputValue !== "undefined") {
                  setInputValue(newInputValue);
                  setTyped(true);
                }
              }}
              value={changedData.guidCurrencyTypeRecNo}
              onChange={(event, newValue) => {
                if (newValue && newValue !== "undefined") {
                  setChangedData({
                    ...changedData,
                    guidCurrencyTypeRecNo: newValue.guidRecNo,
                    chCurrencyTypeName: newValue.chName,
                  });
                  localStorage.setItem(
                    "guidCurrencyTypeRecNo",
                    newValue.guidRecNo
                  );
                }
              }}
              getOptionLabel={(option) => option.chName}
              options={currencyOption}
              noOptionsText="مورد یافت نشد"
              loadingText="در حال جست و جو ..."
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={" نوع ارز"}
                  fullWidth
                  placeholder="جست و جو ..."
                />
              )}
            />
          )}
          <TextInput
            label="  نرخ برابری ارز با ریال"
            onChange={(e) =>
              setChangedData({ ...changedData, moCurrencyExchangePrice: e })
            }
            value={changedData.moCurrencyExchangePrice || ""}
            number
            noSepreate
            price
          />
          <TextInput
            label=" کارمزد فروش ارزش"
            onChange={(e) =>
              setChangedData({ ...changedData, moCurrencyWage: e })
            }
            value={changedData.moCurrencyWage || ""}
            number
            price
          />{" "}
          <TextInput
            label=" تخفیف"
            onChange={(e) => setChangedData({ ...changedData, moDiscount: e })}
            value={changedData.moDiscount || ""}
            number
            price
          />{" "}
          {/*    <TextInput
            label="  مالیات بر ارزش افزوده "
            onChange={(e) =>
              setChangedData({ ...changedData, flValueAddedPercent: e })
            }
            value={changedData.flValueAddedPercent}
            number
            noSepreate
            price
            priceLabel="%"
          /> */}
        </div>
        <div className="flex col-span-2 justify-between items-center mt-5">
          <Button
            disabled={
              !changedData?.flCurrencyAmount ||
              !changedData?.moCurrencyWage ||
              !changedData?.moCurrencyExchangePrice
            }
            onClick={() => {
              setData(changedData);
              if (id) {
                navigate(`/buy/invoice/${id}`);
              } else {
                navigate(`/buy/invoice/create`);
              }
            }}
            sx={{ width: "8rem" }}
            variant="contained"
            color="primary"
          >
            <> ویرایش</>
          </Button>{" "}
          <Button
            onClick={() => {
              if (id) {
                navigate(`/buy/invoice/${id}`);
              } else {
                navigate(`/buy/invoice/create`);
              }
              setChangedData(data);
            }}
            sx={{ width: "8rem", background: "#ccc" }}
            variant="contained"
            color="inherit"
          >
            انصرف
          </Button>
        </div>
      </Box>
    </div>
  );
};

export default CurrencyModal;
